//@ts-check

import { array, number, object, string } from 'yup';

const PriceSchema = object()
    .shape({
        amount: number()
            .integer()
            .typeError('Price must be a number')
            .positive('Price must be more than 0')
            .required('Price is a required field'),
        currency: string().required().max(3),
    })
    .required();

export const ProductOptionSchema = object().shape({
    eanCode: string().required("A product's EAN code is required"),
    SKU: string().required("A product's SKU is required"),
    stockLevel: number()
        .typeError('Value must be a number')
        .required("A product's stock level is required"),
    value: string().required("A product's size is required"),
});

export const ProductMediaSchema = object().shape({
    url: string().required('A main image is required'),
    name: string(),
});

export const LaunchProductSchema = object().shape({
    description: string().required('Description is required'),
    faciaCode: string().required('Facia is required'),
    launchDate: string().required('Launch Date is required'),
    launchType: string().required('Launch Type is required'),
    media: object().shape({
        mainImage: ProductMediaSchema.required('A main image is required'),
        images: array().of(ProductMediaSchema).required('At least one product image is required'),
        videos: array().of(ProductMediaSchema),
        spin: array().of(string()),
    }),
    name: string().required('Name is required'),
    PLU: string().matches(/^\d+$/, 'PLU must be a number').required('PLU is required'),
    price: PriceSchema,
    productOptions: object().shape({
        size: array().of(ProductOptionSchema).required('At least one product size should be added'),
    }),
    status: string().required('Product status is required'),
});

export const emptyLaunchProduct = {
    description: '',
    faciaCode: 'jd',
    launchDate: new Date(),
    launchType: '',
    media: {
        mainImage: undefined,
        images: [],
        videos: [],
    },
    name: '',
    PLU: '',
    price: {
        amount: 0,
        currency: 'GBP',
    },
    productOptions: {
        size: [],
    },
    status: '',
};
